"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/checkbox/style/css");

var _checkbox = _interopRequireDefault(require("antd/es/checkbox"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

var _react = _interopRequireWildcard(require("react"));

var _FroalaCustomUpload = _interopRequireDefault(require("../FroalaCustomUpload"));

require("../activity.scss");

var _Util = require("../../util/Util");

var _ActivityFormContainer = require("../ActivityFormContainer");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _form.default;
const itemStyle = {
  width: '100%',
  marginBottom: '10px',
  marginTop: '10px'
};

class FeedbackItem extends _react.Component {
  constructor() {
    super(...arguments);

    this.onTitleChange = e => {
      const {
        feedback,
        updateFeedback
      } = this.props;
      e.preventDefault();
      feedback.title = e.target.value;
      updateFeedback(feedback);
    };

    this.onMinChange = e => {
      const {
        feedback,
        updateFeedback
      } = this.props;
      const {
        value
      } = e.target;
      const reg = /[0-9]*(\.[0-9]*)?$/;

      if (value.length && reg.test(value) || value === '' || value === '-') {
        const min = parseInt(value);

        if (!isNaN(min)) {
          feedback.min = min;
        } else {
          feedback.min = undefined;
        }
      }

      updateFeedback(feedback);
    };

    this.onMaxChange = e => {
      const {
        feedback,
        updateFeedback
      } = this.props;
      const {
        value
      } = e.target;
      const reg = /[0-9]*(\.[0-9]*)?$/;

      if (value.length && reg.test(value) || value === '' || value === '-') {
        const max = parseInt(value);

        if (!isNaN(max)) {
          feedback.max = max;
        } else {
          feedback.max = undefined;
        }
      }

      updateFeedback(feedback);
    };

    this.onTextChange = value => {
      const {
        feedback,
        updateFeedback
      } = this.props;
      feedback.text = (0, _Util.updateCmsEditorBeforeSave)(value);
      updateFeedback(feedback);
    };

    this.onOverallChange = e => {
      const {
        feedback,
        updateFeedback
      } = this.props;
      feedback.min = 0;
      feedback.max = undefined;
      feedback.isOverallFeedback = e.target.checked;
      updateFeedback(feedback);
    };

    this.validateFeedbackTitle = (rule, value) => {
      const {
        feedback
      } = this.props;

      try {
        if (feedback && feedback.title && feedback.title.length === 0) {
          throw new Error('Feedback title is required.');
        }

        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    };

    this.validateFeedbackText = (rule, value) => {
      const {
        feedback
      } = this.props;

      try {
        if (feedback && feedback.text.length === 0) {
          throw new Error('Feedback text is required.');
        }

        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    };

    this.validateFeedbackPointRange = (rule, value) => {
      const {
        feedback
      } = this.props;

      try {
        if (feedback && feedback.min == undefined) {
          throw new Error('Feedback must have min point value defined.');
        }

        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    };
  }

  render() {
    // Including options in the props so that in the future we could
    // display which options would lead to the feedback based on the
    // feedback's min/max and the option's points.
    const {
      type,
      disabled,
      feedback
    } = this.props;
    const {
      text,
      title,
      min,
      max,
      uuid,
      isOverallFeedback,
      id
    } = feedback; // Only display min/max options for activity-level feedback,
    // not option or question level.

    const displayMinMax = _ActivityFormContainer.Type.zero === type && !isOverallFeedback || _ActivityFormContainer.Type.question === type;
    const isOverall = _ActivityFormContainer.Type.zero === type && (isOverallFeedback || min === 0 && max === null);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "feedback-container"
    }, /*#__PURE__*/_react.default.createElement(Item, {
      key: `feedback-title-${id || uuid}`,
      name: `feedback-title-${id || uuid}`,
      style: itemStyle,
      initialValue: title
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      spellCheck: true,
      disabled: disabled,
      key: `feedback-title-input-${id || uuid}`,
      placeholder: title || 'Feedback title',
      onChange: this.onTitleChange,
      style: {
        width: '100%'
      }
    })), _ActivityFormContainer.Type.zero === type && /*#__PURE__*/_react.default.createElement(_checkbox.default, {
      disabled: disabled,
      checked: isOverall,
      onChange: this.onOverallChange
    }, "Overall Feedback"), /*#__PURE__*/_react.default.createElement(Item, {
      key: `feedback-text-${id || uuid}`,
      name: `feedback-text-${id || uuid}`,
      style: itemStyle,
      validateTrigger: ['onChange', 'onBlur', 'onFocus'],
      rules: [{
        required: true,
        message: 'Please input feedback text or delete this feedback.',
        validator: this.validateFeedbackText
      }],
      valuePropName: "model",
      initialValue: text
    }, /*#__PURE__*/_react.default.createElement(_FroalaCustomUpload.default, {
      disabled: disabled,
      onChange: this.onTextChange
    })), displayMinMax && /*#__PURE__*/_react.default.createElement(Item, {
      key: `feedback-range-${id || uuid}`,
      name: `feedback-range-${id || uuid}`,
      style: itemStyle,
      validateTrigger: ['onChange', 'onBlur', 'onFocus'],
      rules: [{
        required: true,
        validator: this.validateFeedbackPointRange
      }],
      className: "feedback-prop"
    }, "Point Range:", ' ', /*#__PURE__*/_react.default.createElement(_input.default, {
      spellCheck: true,
      disabled: disabled,
      size: "small",
      value: min,
      min: 0,
      onChange: this.onMinChange,
      style: {
        width: '20%'
      }
    }), ' ', "to", ' ', /*#__PURE__*/_react.default.createElement(_input.default, {
      disabled: disabled,
      size: "small",
      value: max,
      min: min,
      onChange: this.onMaxChange,
      style: {
        width: '20%'
      }
    })));
  }

}

var _default = FeedbackItem;
exports.default = _default;